import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import LeadAppointmentEvent from "../../../model/lead/event/LeadAppointmentEvent";
import Appointment from "../../../model/appointment/Appointment";
import AppointmentStatus, {AppointmentStatusEnum} from "../../../model/appointment/AppointmentStatus";
import LeadAppointmentStatusEvent from "../../../model/lead/event/LeadAppointmentStatusEvent";
import {deleteAppointment, updateAppointment} from "../../../store/action/appointment/appointment";
import {connect, Dispatch} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import Toast from "../../helper/Toast";
import {option, Option} from "ts-option";
import ConfirmAppointmentStatusChangeModal from "../../appointment/ConfirmAppointmentStatusChangeModal";
import IndividualContact from "../../../model/contact/IndividualContact";
import ConfirmDeleteAppointmentModal from "../../appointment/ConfirmDeleteAppointmentModal";
import {OnSuccess} from "../../../store/action/actionHelpers";
import {getLeadByIdOrRefNo} from "../../../store/view/lead";
import {store} from "../../../navigation/ReduxProvider";
import CommonStreamItem, {StreamItemAction} from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {AppointmentTypeEnum} from "../../../model/appointment/AppointmentType";
import {getIndividualContact} from "../../../store/view/contact";
import moment = require("moment");
import {getAppointment} from "../../../store/view/appointment";

interface ComponentProps {
	/**
	 * Lead activity to display.
	 */
	activity: LeadAppointmentEvent | LeadAppointmentStatusEvent;
	/**
	 * On edit appointment click
	 * @param {Appointment} appointment
	 */
	onEditAppointmentClick?: (appointmentId: string) => void;
	/**
	 * Disabled edit, un/confirm and delete actions
	 */
	readOnly?: boolean;
}

interface ReduxProps {
	/**
	 * Lead appointments.
	 */
	appointment: Option<Appointment>;
	/**
	 * Appointment lead primary contact.
	 */
	contact: Option<IndividualContact>
}

interface DispatchProps {
	/**
	 * Update appointment
	 * @param {string} leadId
	 * @param {Appointment} appointment
	 */
	updateAppointment: (leadId: string, appointment: Appointment) => void;
	/**
	 * Delete appointment
	 * @param {string} appointmentId
	 * @param {OnSuccess} onSuccess
	 */
	deleteAppointment: (appointmentId: string, leadId: string, onSuccess: OnSuccess) => void;
}

interface State {
	deleteAppointmentConfirmationVisible: boolean,
	confirmationVisible: boolean,
	surveyAppointment: boolean;
}

type Props = ComponentProps & ReduxProps & DispatchProps & RouteComponentProps<{}>;

class LeadActivityAppointmentItem extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			confirmationVisible: false,
			deleteAppointmentConfirmationVisible: false,
			surveyAppointment: props.appointment.map(
				a => a.type.map(at => at.name === AppointmentTypeEnum.Survey).getOrElse(false)).getOrElse(false),
		};
		this.editAppointmentClick = this.editAppointmentClick.bind(this);
		this.unConfirmAppointmentClick = this.unConfirmAppointmentClick.bind(this);
		this.confirmAppointmentClick = this.confirmAppointmentClick.bind(this);
		this.onModalConfirm = this.onModalConfirm.bind(this);
		this.isConfirmed = this.isConfirmed.bind(this);
		this.isCurrent = this.isCurrent.bind(this);
		this.deleteAppointmentClick = this.deleteAppointmentClick.bind(this);
		this.deleteAppointment = this.deleteAppointment.bind(this);
	}

	componentWillReceiveProps(nextProps: Props) {
		const appointmentTypeName = this.props.appointment.flatMap(a => a.type.map(at => at.name)).getOrElse("");
		const nextAppointmentTypeName = nextProps.appointment.flatMap(na => na.type.map(nat => nat.name)).getOrElse("");
		if (appointmentTypeName !== nextAppointmentTypeName) {
			this.setState({
				surveyAppointment: nextProps.appointment.map(
					a => a.type.map(at => at.name === AppointmentTypeEnum.Survey).getOrElse(false)).getOrElse(false)
			})
		}
	}

	render() {
		return (
			this.props.appointment.map(a =>
				<React.Fragment>
					<CommonStreamItem event={this.props.activity} actions={this.getActions()}/>
					{this.state.confirmationVisible &&
					<ConfirmAppointmentStatusChangeModal onClose={() => this.setState({confirmationVisible: false})}
														 onConfirm={this.onModalConfirm}
														 surveyWithEmail={this.props.contact.map(
															 c => c.hasEmailAddress()).getOrElse(false)
														 && this.state.surveyAppointment}
														 surveyWithMobile={this.props.contact.map(
															 c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)
														 && this.state.surveyAppointment}/>}
					{this.state.deleteAppointmentConfirmationVisible &&
					<ConfirmDeleteAppointmentModal
						onClose={() => this.setState({deleteAppointmentConfirmationVisible: false})}
						onConfirm={this.deleteAppointment}/>}
				</React.Fragment>
			).orNull
		)
	}

	getActions(): StreamItemAction[] {
		let actions: StreamItemAction[] = [];
		if (!this.props.readOnly) {
			const removable = this.props.appointment.map(a => a.dateTime.isAfter(moment())).getOrElse(false);
			actions.push(StreamItemAction.new("Edit", this.editAppointmentClick));
			if (this.isCurrent()) {
				actions.push(this.isConfirmed() ?
					StreamItemAction.new("Unconfirm", this.unConfirmAppointmentClick) :
					StreamItemAction.new("Confirm", this.confirmAppointmentClick))
			}
			if (removable) {
				actions.push(StreamItemAction.new("Delete", this.deleteAppointmentClick))
			}
		}
		return actions;
	}

	isConfirmed() {
		return this.props.appointment.map(a => a.status.value === AppointmentStatusEnum.Confirmed).getOrElse(false);
	}

	isCurrent() {
		return this.props.appointment.map(a => a.dateTime.isSameOrAfter(moment())).getOrElse(false);
	}

	editAppointmentClick() {
		this.props.onEditAppointmentClick && this.props.onEditAppointmentClick(this.props.activity.data.appointmentId);
	}

	confirmAppointmentClick() {
		this.props.appointment.map((appointment) => {
			if ((this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)
				|| this.props.contact.map(c => c.hasEmailAddress()).getOrElse(false)) && this.state.surveyAppointment) {
				this.setState({confirmationVisible: true});
			}
			else {
				this.props.updateAppointment(this.props.activity.leadId,
					appointment.copy({status: AppointmentStatus.fromString(AppointmentStatusEnum.Confirmed)}));
			}
		});
	}

	unConfirmAppointmentClick() {
		this.props.appointment.map((appointment) => {
			this.props.updateAppointment(this.props.activity.leadId,
				appointment.copy({status: AppointmentStatus.fromString(AppointmentStatusEnum.Unconfirmed)}));
		});
	}

	onModalConfirm() {
		this.setState({confirmationVisible: false}, () => {
			this.props.appointment.map((appointment) => {
				this.props.updateAppointment(this.props.activity.leadId,
					appointment.copy({status: AppointmentStatus.fromString(AppointmentStatusEnum.Confirmed)}));
			});
		});
	}

	deleteAppointmentClick() {
		this.props.appointment.map(appointment => {
			if (appointment.dateTime.isAfter(moment()))
				this.setState({deleteAppointmentConfirmationVisible: true});
		});
	}

	deleteAppointment() {
		this.props.appointment.map(a => this.props.deleteAppointment(a.id, a.leadId.orNull,
			() => this.setState({deleteAppointmentConfirmationVisible: false})
		))
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const lead = getLeadByIdOrRefNo(props.activity.leadId, store.getState());
	const appointment = getAppointment(props.activity.leadId, props.activity.data.appointmentId, state)
	return ({
		contact: lead.map(l => l.data.principalContactId).flatMap(getIndividualContact),
		appointment
	})
}


function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateAppointment: (leadId: string, appointment: Appointment) => dispatch(
			updateAppointment(leadId, appointment,
				() => {
					Toast.success("Appointment has been updated.", "Update Appointment");
				},
				(error: any) => {
					let err: string;
					if (error && error.response && error.response.status == 412)
						err = `Cannot confirm appointment without assignee.`;
					else
						err = "Sorry, something went wrong. Try again later.";
					Toast.error(err, "Update Appointment");
				})),
		deleteAppointment: (appointmentId: string, leadId: string, onSuccess: OnSuccess) => dispatch(
			deleteAppointment(appointmentId, leadId,
				() => {
					Toast.success("Appointment has been deleted", "Delete appointment");
					onSuccess()
				},
				() => {Toast.error("Something went wrong. Please try again later.", "Delete appointment")}))
	}
}

export default withRouter<ComponentProps>(connect(mapStateToProps, mapDispatchToProps)(LeadActivityAppointmentItem));